import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

export const leaderboardApi = createApi({
  reducerPath: "leaderboardApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    topLeaderboard: builder.query({
      query: ({ page, limit, sortBy, timeframe, symbol, order }) => ({
        url: "users/leaderboard",
        method: "GET",
        params: { page, limit, sortBy, timeframe, symbol, order },
      }),
      keepUnusedDataFor: 0,
    }),
    topEarners: builder.query({
      query: ({ page = 1, type = "total" }: { page?: number; type?: "total" | "zaps" | "likes" }) => ({
        url: "users/earnings-leaderboard",
        method: "GET",
        params: { type, page },
      }),
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useTopLeaderboardQuery, useTopEarnersQuery } = leaderboardApi;
